var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4918_5387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1028 18H0.953288C0.41497 18 0.0560913 17.5765 0.0560913 16.9412C0.0560913 11.6442 0.0560913 6.36308 0.0560913 1.05882C0.0560913 0.423529 0.41497 0 0.953288 0C1.49161 0 1.85048 0.423529 1.85048 1.05882V9.30003L5.70844 5.5059C6.06732 5.18826 6.60564 5.18826 6.87479 5.61179L9.83554 9.1059L14.2704 5L13 5C12.4477 5 12 4.55229 12 4C12 3.44772 12.4477 3 13 3L16.5 3.00001C17.0523 3.00001 17.5 3.44772 17.5 4.00001L17.5 7.5C17.5 8.05229 17.0523 8.5 16.5 8.5C15.9477 8.5 15.5 8.05228 15.5 7.5L15.5 6.5197L10.3739 11.3294C10.015 11.6471 9.47666 11.6471 9.11779 11.3294L6.06732 7.72943L1.85048 11.8609V15.8824H17.1028C17.6411 15.8824 18 16.3059 18 16.9412C18 17.5765 17.6411 18 17.1028 18Z",
    fill: "#ee0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4918_5387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/StatisticsIcon.3bbd99c5.svg";
export { ForwardRef as ReactComponent };